/**
 * Standalone AppContext — extracted to break circular import chain.
 *
 * IMPORTANT: This file must NOT import from '@src/app' (the barrel),
 * from routes, or from any module that eventually imports with-service.
 * It only imports from leaves of the dependency tree (service, styles).
 *
 * Import chain that broke before this file existed:
 *   with-service.tsx → '@src/app' barrel → routes → documents → with-service  (circular!)
 *
 * Now with-service.tsx imports from '@src/app/app-context' (this file),
 * which has no circular path back to with-service.
 */
import * as React from 'react'
import { Service } from '@src/service'
import { Themes } from '@src/styles/theme'

export interface AppReducerState {
  service: Service
  theme: Themes
  organizationReload?: () => void
}

export interface AppDispatchProps {
  dispatch: (action: any) => void
}

export const AppContext = React.createContext<Partial<AppReducerState> & AppDispatchProps>({
  theme: Themes.EQUA,
  dispatch: () => { },
})
